export default {
  timeslot: state => state.timeslot,
}
